// src/pages/SubstationDetails.jsx
import React, { useEffect, useState } from "react";
import { useLocation, useParams, Link } from "react-router-dom";
import Layout from "../components/Layout";
import apiFetch from "../utils/apiFetch";

const ENTITY_TITLES = {
  substation: "Подстанция",
  transformer: "Силовой трансформатор",
  breaker: "Выключатель",
  "current-transformer": "Трансформатор тока",
  "voltage-transformer": "Трансформатор напряжения",
  disconnector: "Разъединитель",
  reactor: "Реактор",
  battery: "Аккумулятор батарея",
  arrester: "Разрядник",
};

// соответствие entityType -> имени коллекции в ответе /api/substation/:slug
const ENTITY_COLLECTION_KEYS = {
  transformer: "substation_transformers",
  breaker: "substation_breakers",
  "current-transformer": "substation_current_transformers",
  "voltage-transformer": "substation_voltage_transformers",
  disconnector: "substation_disconnectors",
  reactor: "substation_reactors",
  battery: "substation_batteries",
  arrester: "substation_arresters",
};

const SubstationDetails = () => {
  const { slug, entityType, id } = useParams();
  const location = useLocation();

  // если перешли по кнопке "Батафсил" — html уже прилетел через state
  const detailFromState = location.state?.detailValue || "";

  const [html, setHtml] = useState(detailFromState);
  const [loading, setLoading] = useState(!detailFromState);
  const [error, setError] = useState(null);

  const title = ENTITY_TITLES[entityType] || "Батафсил маълумот";

  useEffect(() => {
    // если html уже есть (перешли с карты/паспортной страницы) — API не трогаем
    if (detailFromState) return;

    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await apiFetch(`/api/substation/${slug}`, { cache: "no-store" });

        if (!res.ok) {
          throw new Error(`Failed to load substation: ${res.status}`);
        }

        const data = await res.json();

        let detailsHtml = "";

        if (entityType === "substation") {
          detailsHtml = data?.details || "";
        } else {
          const collectionKey = ENTITY_COLLECTION_KEYS[entityType];
          const arr =
            collectionKey && Array.isArray(data[collectionKey])
              ? data[collectionKey]
              : [];

          const numericId = Number(id);
          const entity = arr.find((item) => Number(item.id) === numericId);

          detailsHtml = entity?.details || "";
        }

        if (!cancelled) {
          setHtml(detailsHtml);
        }
      } catch (e) {
        console.error("Failed to load details", e);
        if (!cancelled) {
          setError("Маълумотни юклашда хатолик юз берди.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [slug, entityType, id, detailFromState]);

  return (
    <Layout>
      <div className="container">
        <div className="pole-page">
          <div className="pole-page__head">
            <div className="pole-page__breadcrumbs">
              <Link to="/" className="pole-page__breadcrumbs-link">
                Барча кўрсаткичлар
              </Link>
              <span className="pole-page__breadcrumbs-separator">/</span>
              <Link
                to="/indicators/substations"
                className="pole-page__breadcrumbs-link"
              >
                Подстанциялар
              </Link>
              <span className="pole-page__breadcrumbs-separator">/</span>
              <Link
                to={`/indicators/substations/${slug}`}
                className="pole-page__breadcrumbs-link"
              >
                Подстанция
              </Link>
              <span className="pole-page__breadcrumbs-separator">/</span>
              <span className="pole-page__breadcrumbs-current">
                {title}
              </span>
            </div>

            <div className="pole-page__head-row">
              <h1 className="pole-page__title">{title}</h1>
            </div>
          </div>

          {loading ? (
            <p>Юкланмоқда...</p>
          ) : error ? (
            <p>{error}</p>
          ) : html ? (
            <div style={{ overflowX: "auto" }}>
              <div dangerouslySetInnerHTML={{ __html: html }} />
            </div>
          ) : (
            <p>Маълумот топилмади.</p>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default SubstationDetails;
